import { ReactElement, useState } from 'react'
import { PurchaseOrderLine} from './api/purchaseorder'
import { SalesOrderLine} from './api/salesorder'
import  {OrderLinesTableProps, PurchaseOrderLinesTable, SalesOrderLinesTable}
  from './OrderLinesTable'
import {ISODate} from "./date"
import {SlideOpenClose} from "./SlideOpenClose"
import "./LinesWarning.scss"
 
type Props = ((
  {
    type: "purchase"
  } & OrderLinesTableProps<PurchaseOrderLine>
) | (
  {
    type: "sales"
  } & OrderLinesTableProps<SalesOrderLine>
)) & {
  itemPropertyDescription: string | ReactElement
}

export function LinesWarning(props: Props): ReactElement {
  const {type, items, itemPropertyDescription } = props
  const [isOpen, setIsOpen] = useState(false)

  return <div className={isOpen ? "LinesWarning open" : "LinesWarning closed"}>
    <div className={items.length ? "opener warning" : "opener good"} onClick={
      () => setIsOpen(b => !b && items.length > 0)}>
      There {items.length === 1 ? "is" : "are"} {items.length} {type} order line{
        items.length === 1 ? "" : "s"} {itemPropertyDescription}
    </div>
    <SlideOpenClose isOpen={isOpen}>
      <div className="body" >
        {type === "purchase" &&
          <PurchaseOrderLinesTable items={props.items} />
        }
        {type === "sales" &&
          <SalesOrderLinesTable items={props.items} />
        }
      </div>
    </SlideOpenClose>
  </div>
}


export function POAlmostPastDueWithoutShippingWarning(
  {items}: OrderLinesTableProps<PurchaseOrderLine>
): ReactElement {
  const [cutoffDate, setCutoffDate] = useState<ISODate>(ISODate.localToday().add(7))
  const itemsAlmostOverdueWithoutShipping = items.filter(
    pol => pol.$calc.shipping.length === 0 && pol.receiptDate.lt(cutoffDate))

  return <LinesWarning
    type="purchase"
    items={itemsAlmostOverdueWithoutShipping}
    itemPropertyDescription={
      <> due within
    <select data-cy="almost-overdue" value={cutoffDate.toISOString()}
    onClick={e => e.stopPropagation()}
    onChange={e => setCutoffDate(ISODate.parseISO(e.target.value))}>
    {Array.from(Array(90).keys()).map(offset => {
      const date = ISODate.localToday().add(offset)
      return <option value={date.toISOString()} key={offset.toString()}>
        {offset}
      </option>
    })}
    </select>
    days (before {cutoffDate.toDDMMYYYYString()})
    but don't have shipping information.
          </>
    }
    />
}
